import { Component, OnInit, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA,
  MatLegacyDialogRef
} from '@angular/material/legacy-dialog';
import { GetItemListFieldsService } from '../../../shared/services/get-item-list-fields.service';
import { Item } from '@sitecore-jss/sitecore-jss/layout';
import { ToAccountsListForTransfersResponse } from '../../../transfers/services/to-accounts.service';
import {
  IAccountTransferPermissions,
  ITransferOptions
} from '../../../transfers/services/internal-accounts.service';
import TRANSFER_TYPE from '../../../transfers/enums/transfer-type';
import { ISecurityAddressBook } from '../../../shared/interfaces/address-book.interfaces';

@Component({
  selector: 'ab-address-book-popup',
  templateUrl: './address-book-popup.component.html',
  styleUrls: ['./address-book-popup.component.scss']
})
export class AddressBookPopupComponent implements OnInit {
  public items: { [key: string]: Item };
  public securityAddressBook: ISecurityAddressBook;

  get hideCompanies() {
    return (
      !this.data.data.transferOptions.billTransferAllowed ||
      this.data.data.transferType === TRANSFER_TYPE.internationalTransfer
    );
  }

  get hideOwnAccounts() {
    return (
      !this.data.data.transferOptions.internalTransferAllowed ||
      this.data.data.transferType === TRANSFER_TYPE.internationalTransfer
    );
  }

  get hideContacts() {
    return (
      !this.data.data.transferOptions.domesticTransferAllowed &&
      this.data.data.transferType !== TRANSFER_TYPE.internationalTransfer
    );
  }

  get domesticPermissionsEnabled() {
    return (
      this.data.data.transferType === TRANSFER_TYPE.internationalTransfer ||
      this.data.data.permissions.domesticTransferEnabled
    );
  }

  get billTransferPermissionsEnabled() {
    return this.data.data.permissions.billTransferEnabled;
  }

  get internalPermissionsEnabled() {
    return this.data.data.permissions.internalTransferEnabled;
  }

  constructor(
    @Inject(MAT_LEGACY_DIALOG_DATA)
    public data: {
      data: {
        dialogData: ToAccountsListForTransfersResponse;
        transferOptions: ITransferOptions;
        transferType: TRANSFER_TYPE;
        permissions: IAccountTransferPermissions;
      };
      fields: any;
    },
    public dialogRef: MatLegacyDialogRef<AddressBookPopupComponent>,
    private getItemListFieldsService: GetItemListFieldsService
  ) {}

  ngOnInit() {
    this.items = this.getItemListFieldsService.getItems(this.data.fields.items);

    this.securityAddressBook = {
      billTransferPermissionsEnabled: this.billTransferPermissionsEnabled,
      domesticPermissionsEnabled: this.domesticPermissionsEnabled,
      hideCompanies: this.hideCompanies,
      hideContacts: this.hideContacts,
      hideOwnAccounts: this.hideOwnAccounts,
      internalPermissionsEnabled: this.internalPermissionsEnabled
    };
  }

  select(item: any) {
    this.dialogRef.close(item);
  }
}
